export default "__VITE_ASSET__CIf6zD$o__"